import { useState } from "react";
import { Check, Copy } from "lucide-react";

const INSTALL_CMD = "npm install @noeracle/sdk";

export function CtaInstall() {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(INSTALL_CMD);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      // Fall back to a hidden textarea
      const ta = document.createElement("textarea");
      ta.value = INSTALL_CMD;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    }
  }

  return (
    <button
      type="button"
      onClick={copy}
      className="group inline-flex items-center gap-3 rounded-lg border border-border bg-surface/60 px-5 py-3 font-mono text-[13px] text-text transition-colors hover:border-emerald/60 hover:bg-surface"
      aria-label="Copy install command"
    >
      <span className="text-emerald select-none">$</span>
      <span>{INSTALL_CMD}</span>
      <span className="ml-2 inline-flex items-center gap-1 font-mono text-[9.5px] uppercase tracking-[0.22em] text-m45 group-hover:text-emerald transition-colors">
        {copied ? (
          <>
            <Check className="size-3" /> COPIED
          </>
        ) : (
          <>
            <Copy className="size-3" /> COPY
          </>
        )}
      </span>
    </button>
  );
}
